// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class ZoneGeoResource extends Resource {
    basePath: string = 'sites/sites/{parent}/zones/geo/';

    objectPath: string = 'sites/sites/{parent}/zones/geo/{ident}/';
}
